export const EXTERNAL_SOCIAL_URLS = {
  twitter: 'https://twitter.com',
  youtube: 'https://www.youtube.com/channel/',
  instagram: 'https://www.instagram.com/',
  facebook: 'https://www.facebook.com/',
  discord: 'https://discord.com/invite/',
};
